module.exports = __webpack_public_path__ + "img/icon-01.ea027f10.png";